'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var orderDetailDeliveriesComponent = exports.orderDetailDeliveriesComponent = {
    template: require('./order-detail-deliveries.html'),
    bindings: {
        order: '<'
    },
    controllerAs: 'vm',
    controller: ["common", "Enums", "gettextCatalog", function orderDetailDeliveriesController(common, Enums, gettextCatalog) {
        'ngInject';

        var vm = this;
        vm.$onInit = init;
        vm.orderStatusTexts = {};
        vm.getOrderStatusText = getOrderStatusText;
        vm.getDeliveryStatusText = getDeliveryStatusText;

        function init() {
            vm.orderStatusTexts = Enums.orderStatusTexts;
            vm.deliveryStatusTexts = Enums.deliveryStatusTexts;
        }

        function getOrderStatusText(code) {
            return code ? gettextCatalog.getString(vm.orderStatusTexts[code].text) : '';
        }

        function getDeliveryStatusText(code) {
            if (!code) {
                return '';
            }
            return code ? gettextCatalog.getString(vm.deliveryStatusTexts[code].text) : '';
        }
    }]
};


//////////////////
// WEBPACK FOOTER
// ./features/account/components/order-detail-deliveries.js
// module id = 838
// module chunks = 0